import { DataGridPayload } from 'vnetwork-ui/dist/components/GokuDataGrid'
import { ResponseArray, ResponseObject } from '@/types/shared'
import datacentral from '@/utils/axios/datacentral'
import {
    DocumentShareRequest,
    Documents,
    DocumentVersion,
} from '../types/reponse'
import qs from 'query-string'
import { ErrorResponse } from 'react-router-dom'
import { getEmployees } from '@/modules/Employee/services'
import { DocumentCreatePayload } from '../types/payload'
import { Attachment } from '@/modules/Upload/types'
import { ActivityPayload, ActivityType } from '@/components/Activities'

// Get All Document
export const getDocument = async (
    payload: DataGridPayload
): Promise<ResponseArray<Documents>> => {
    const response = await datacentral.get(
        `/documents?${qs.stringify(payload)}`
    )
    return response?.data
}
// Delete Document
export const deleteDocument = async (
    documentID: number
): Promise<ResponseObject<Documents> | ErrorResponse> => {
    const response = await datacentral.delete(`documents/${documentID}`)
    return response?.data
}

export const getDocumentVersion = async (
    payload: DataGridPayload
): Promise<ResponseObject<DocumentVersion>> => {
    const response = await datacentral.get(
        `documents/version/documentID?${qs.stringify(payload)}`
    )
    return response?.data
}
export const asyncEmployeeOptions = async (value: string) => {
    const response = await getEmployees({
        q: value,
        page: 1,
        page_size: 10,
    })
    if (!response?.message) return []

    return response.results.map((employee) => ({
        label: employee.employee_name,
        value: employee.employee_id,
    }))
}
export const createDocument = async (
    payload: DocumentCreatePayload & { attachments: Attachment[] }
): Promise<ResponseObject<Documents> | ErrorResponse> => {
    const response = await datacentral.post(`documents`, payload)
    return response?.data
}
export const getDocumentById = async (documentID: number) => {
    const response = await datacentral.get<Promise<ResponseObject<Documents>>>(
        `documents/${documentID}`
    )
    return response?.data
}
export const updateDocument = async (payload: {
    documentID: number
    document: DocumentCreatePayload & {
        attachments: Attachment[]
        release_scope: string
    }
}): Promise<ResponseObject<Documents> | ErrorResponse> => {
    const response = await datacentral.put(
        `/documents/${payload.documentID}`,
        payload.document
    )
    return response?.data
}

// Get All Document
export const getDocumentShareWithMe = async (
    payload: DataGridPayload
): Promise<ResponseArray<Documents>> => {
    const response = await datacentral.get(
        `/documents/shared-with-me?${qs.stringify(payload)}`
    )
    return response?.data
}

export const getMyDocumentShared = async (
    payload: DataGridPayload
): Promise<ResponseArray<Documents>> => {
    const response = await datacentral.get(
        `/documents/my-document-sharing?${qs.stringify(payload)}`
    )
    return response?.data
}

export const getDocumentLogs = async (
    documentID: number,
    payload: ActivityPayload
) => {
    const response = await datacentral.get<ResponseArray<ActivityType>>(
        `/documents/${documentID}/logs?${qs.stringify(payload)}`
    )
    return response?.data
}

// List share requests
export const listShareRequests = async (
    payload: DataGridPayload
): Promise<ResponseArray<DocumentShareRequest>> => {
    const response = await datacentral.get(
        `/documents/share-requests?${qs.stringify(payload)}`
    )
    console.log('response', response)
    return response?.data
}

// Approve share request
export const approveShareRequest = async (
    requestId: number
): Promise<ResponseObject<DocumentShareRequest> | ErrorResponse> => {
    const response = await datacentral.put(
        `/documents/share-requests/${requestId}/approve`
    )
    console.log('response', response)
    return response?.data
}

// Reject share request
export const rejectShareRequest = async (
    requestId: number
): Promise<ResponseObject<DocumentShareRequest> | ErrorResponse> => {
    const response = await datacentral.put(
        `/documents/share-requests/${requestId}/reject`
    )
    return response?.data
}
